import { render, staticRenderFns } from "./FileInsertor.vue?vue&type=template&id=f160a4d4&scoped=true"
import script from "./FileInsertor.vue?vue&type=script&lang=js"
export * from "./FileInsertor.vue?vue&type=script&lang=js"
import style0 from "./FileInsertor.vue?vue&type=style&index=0&id=f160a4d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f160a4d4",
  null
  
)

export default component.exports